// extracted by mini-css-extract-plugin
export var menuItem = "B_tx d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "B_ty d_Z d_bz d_bP";
export var menuMainLink = "B_tz d_f0 d_dB";
export var menuLink = "B_tB d_f0 d_dB";
export var icon = "B_p9 d_bC d_bP";
export var divider = "B_tC d_bC d_bP";
export var sublinks = "B_tD";
export var link = "B_mC";
export var Link = "B_s4 z_s4 z_ss z_sN";